import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function ResourceManagerDefaultWidget(props) {
  return (
    <DefaultWidgetTemplate
      module={props.module}
      route="user_module_resourceManager_resource_home"
    />
  );
}
